const interfacePhrases = {
    rate_limited: 'จำกัดความถี่',
    limit_exceeded: 'เกินขีดจำกัด',
    used: 'การใช้งาน',
    identifier: 'ตัวระบุ',
    verification: 'การตรวจสอบ',
    messages: 'ข้อความ',
    data: 'ข้อมูล',
    custom: 'กำหนดเอง',
    management_api: 'API การจัดการ {{product}}',
    management_api_role_description: 'บทบาทในตัวนี้ให้สิทธิ์เข้าถึง API การจัดการ',
    client_credentials: 'ข้อมูลรับรองไคลเอนต์',
    authentication_request: 'คำขอยืนยันตัวตน',
    callback: 'การเรียกกลับการยืนยันตัวตน',
    help_title: 'ศูนย์ช่วยเหลือ iden',
    help_subtitle: 'ดูคำแนะนำโดยไม่ต้องออกจากพื้นที่ทำงาน',
    open_help: 'เปิดหน้าช่วยเหลือแบบเต็ม',
    close_help: 'ปิดความช่วยเหลือ',
    about: 'เกี่ยวกับและโอเพนซอร์ส',
    open_navigation: 'เปิดเมนูนำทาง',
    close_navigation: 'ปิดเมนูนำทาง',
    development_enabled: 'เปิดใช้ฟีเจอร์สำหรับการพัฒนาแล้ว',
    beta: 'รุ่นเบตา',
    impersonation: 'การสวมสิทธิ์ผู้ใช้',
    key: 'คีย์',
    value: 'ค่า',
    error: 'ข้อผิดพลาด',
    details: 'รายละเอียดทางเทคนิค',
    callback_failed: 'ไม่สามารถดำเนินการเรียกกลับเพื่อเข้าสู่ระบบให้เสร็จสิ้นได้',
    back_sign_in: 'กลับไปเข้าสู่ระบบ',
    powered_by: 'ขับเคลื่อนโดย',
    avatar: 'รูปประจำตัว',
    logo: 'โลโก้',
    qr_code: 'รหัสคิวอาร์',
    sample_title: 'ต้องการดูตัวอย่างไหม',
    sample_description: 'สำรวจแอปพลิเคชันตัวอย่างที่ใช้คู่มือนี้',
    sample_action: 'ดูตัวอย่าง',
    further_readings: 'อ่านเพิ่มเติม',
    complete_guide: 'คู่มือฉบับเต็ม',
    custom_domains_notice: 'หลังจากเพิ่ม<a>โดเมนกำหนดเอง</a> คุณสามารถใช้ปลายทางนี้ได้: <code>{{endpoint}}</code>',
    my_project: 'โครงการของฉัน',
    my_secret: 'ข้อมูลลับของฉัน',
    my_token: 'โทเค็นของฉัน',
    role_example: 'ผู้ดู',
    reset_retry: 'รีเซ็ตการตั้งค่าและลองอีกครั้ง',
    open_dev_panel: 'เปิดแผงนักพัฒนา',
    close_dev_panel: 'ปิดแผงนักพัฒนา',
    configuration: 'การตั้งค่า',
    app_id: 'รหัสแอปพลิเคชัน',
    extra_parameters: 'พารามิเตอร์การเข้าสู่ระบบเพิ่มเติม',
    prompt: 'ข้อความแจ้งการยืนยันตัวตน',
    scope: 'ขอบเขต',
    resource: 'ทรัพยากร',
    resources_space_delimited: 'ทรัพยากร (คั่นด้วยช่องว่าง)',
    sign_out_to_apply: 'ออกจากระบบเพื่อใช้การเปลี่ยนแปลง',
    refresh_token_grant: 'การอนุญาตด้วยโทเค็นรีเฟรช',
    organization_id: 'รหัสองค์กร',
    console_result: 'ดูผลลัพธ์ในคอนโซลของเบราว์เซอร์',
    request_token: 'ขอโทเค็น',
    user_info: 'ข้อมูลผู้ใช้',
    get_id_token_claims: 'รับข้อมูลอ้างสิทธิ์จากโทเค็นระบุตัวตน',
    fetch_user_info: 'ดึงข้อมูลผู้ใช้',
    device_initializing: 'กำลังเริ่มต้นการอนุญาตอุปกรณ์…',
    device_success: 'คุณเข้าสู่แอปสาธิตสำเร็จแล้ว',
    sign_in_information: 'ข้อมูลการเข้าสู่ระบบของคุณ:',
    email: 'อีเมล',
    username: 'ชื่อผู้ใช้',
    user_id: 'รหัสผู้ใช้',
    sign_out_demo: 'ออกจากแอปสาธิต',
    device_expired: 'รหัสอุปกรณ์หมดอายุ',
    generic_error: 'เกิดข้อผิดพลาด',
    device_expired_description: 'รหัสอุปกรณ์หมดอายุแล้ว ลองอีกครั้งเพื่อรับรหัสใหม่',
    sign_in_title: 'เข้าสู่ระบบบัญชีของคุณ',
    scan_instruction: 'สแกนรหัสคิวอาร์ หรือเปิดที่อยู่นี้บนอุปกรณ์อื่น:',
    one_time_code: 'ป้อนรหัสแบบใช้ครั้งเดียว',
    token_info: 'ข้อมูลโทเค็น',
    get_access_token: 'รับโทเค็นการเข้าถึง',
    context_unavailable: 'ไม่สามารถโหลดข้อมูลบัญชีได้',
    not_initialized: 'ยังไม่ได้เริ่มต้นข้อมูลบัญชี',
    not_set: 'ยังไม่ได้ตั้งค่า',
    configured: 'ตั้งค่าแล้ว',
    password: 'รหัสผ่าน',
    phone: 'หมายเลขโทรศัพท์',
    search_help: 'ค้นหาความช่วยเหลือ',
    language: 'ภาษา',
    menu: 'เมนู',
    compatibility_notice: 'หมายเหตุความเข้ากันได้: ชื่อ SDK แพ็กเกจ โปรโตคอล คอมโพเนนต์ และส่วนหัวคำขอที่สืบทอดจาก Logto ยังคงเดิม',
    source: 'แหล่งที่มา',
    upstream_repository: 'คลังต้นฉบับ',
    current_fork: 'คลังปัจจุบัน',
    license_notice: 'iden พัฒนาจาก Logto ซึ่งเป็นซอฟต์แวร์โอเพนซอร์สภายใต้ Mozilla Public License 2.0',
    about_description: 'ข้อมูลผลิตภัณฑ์และการแสดงที่มาของโอเพนซอร์ส',
    page_not_found: 'ไม่พบหน้า',
    page_not_found_description: 'หน้านี้ไม่พร้อมใช้งาน โปรดกลับไปที่ศูนย์ช่วยเหลือ',
    introduction: 'บทนำ',
    quick_starts: 'เริ่มต้นอย่างรวดเร็ว',
    integration: 'การผสานรวม',
    end_user_flows: 'ขั้นตอนสำหรับผู้ใช้ปลายทาง',
    authorization: 'การอนุญาต',
    user_management: 'การจัดการผู้ใช้',
    security: 'ความปลอดภัย',
    customization: 'การปรับแต่ง',
    connectors: 'ตัวเชื่อมต่อ',
    organizations: 'องค์กร',
    self_hosting: 'โฮสต์ด้วยตนเอง',
    continue: 'ดำเนินการต่อ',
    loading: 'กำลังโหลด…',
    save: 'บันทึก',
    saved: 'บันทึกแล้ว',
    try_again: 'ลองอีกครั้ง',
    client_id: 'รหัสไคลเอนต์',
    client_secret: 'ข้อมูลลับไคลเอนต์',
    redirect_uri: 'URI เปลี่ยนเส้นทาง',
    status: 'สถานะ',
    type: 'ประเภท',
    permissions: 'สิทธิ์',
    token_data: 'ข้อมูลโทเค็น',
    context_data: 'ข้อมูลบริบท',
    jwt_extra_claims: 'ข้อมูลอ้างสิทธิ์เพิ่มเติมของโทเค็น',
    action_result: 'ผลลัพธ์การดำเนินการ',
    social_account_already_linked: 'บัญชีโซเชียลนี้เชื่อมโยงแล้ว',
};
export default Object.freeze(interfacePhrases);
